import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import axios from 'axios'
import {GET_VIDEO} from './actionTypes'
import fetchData from '../../utils/fetch-data'
// import config from '../../config'
// import getCityAliasAPI from '../../utils/get-city-alias-api'

const useGetVideoActions = () => {
  const dispatch = useDispatch()

  const getVideo = useCallback(
    async baseUrlAlias => {
      // const cityDataJson = await getCityAliasAPI()
      // const baseUrlAlias = cityDataJson.length > 0 ? cityDataJson[0].baseUrlAlias : 'ny'

      dispatch({
        type: GET_VIDEO,
        payload: await fetchData(`/${baseUrlAlias}/get-trailer-link/json/1`),
      })
    },
    [dispatch]
  )
  return {getVideo}
}

export default useGetVideoActions
